<template>
  <div>
    <b-modal
      id="viewconfig"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      :visible="showModal"
      @hidden="$emit('close-modal')"
    >
      <div class="w-100">
        <div class="p-3 d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <div @click="$emit('close-modal')">
              <img src="../../../assets/img/newvendorflow/bckarw.svg" alt="" />
            </div>
            <div class="pff-modal-heading">View Configuration</div>
          </div>
          <div class="pointer" @click="$emit('close-modal')">
            <img
              class="rotate-on-hover"
              src="../../../assets/img/feedbackform/x-close.svg"
              alt=""
            />
          </div>
        </div>
      </div>
      <hr class="m-0" />
      <div class="p-3 kvc-body-container">
        <!-- opening screen display -->
        <div
          class="pointer"
          v-if="!display.showOpenScreen"
          @click="showCard('showOpenScreen')"
        >
          <div
            class="
              p-3
              kanban-viewconfig-card-container
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <div>Opening Screen Display</div>
            <div>
              <img src="../../../assets/img/newvendorflow/downarw.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="" v-else @click="showCard('showOpenScreen')">
          <div class="kanban-viewconfig-opencard-container">
            <div class="pointer">
              <div
                class="
                  kvc-opencard-header
                  px-3
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <div>Opening Screen Display</div>
                <div>
                  <img
                    src="../../../assets/img/newvendorflow/uparw.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="p-3">
              <div>
                <div class="kvc-cards-header">Configuration Name</div>
                <div class="kvc-cards-subheader mt-1">
                  {{ configuration.configName }}
                </div>
              </div>
              <div class="mt-2">
                <div class="kvc-cards-header">Test Organization</div>
                <div class="kvc-cards-subheader mt-1">
                  {{ configuration.config.testOrg }}
                </div>
              </div>
              <div class="mt-2">
                <div class="kvc-cards-header">Test Type</div>
                <div class="kvc-cards-subheader mt-1">
                  {{ configuration.config.test }}
                </div>
              </div>
              <div class="mt-2">
                <div class="kvc-cards-header">Test description</div>
                <div
                  class="kvc-cards-subheader mt-1"
                  v-html="configuration.config.testDesc"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <!-- Question Behaviour-->
        <div
          class="pointer mt-3"
          v-if="!display.showQuesBehav"
          @click="showCard('showQuesBehav')"
        >
          <div
            class="
              p-3
              kanban-viewconfig-card-container
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <div>Question Behaviour</div>
            <div>
              <img src="../../../assets/img/newvendorflow/downarw.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="mt-3" v-else @click="showCard('showQuesBehav')">
          <div class="kanban-viewconfig-opencard-container">
            <div class="pointer">
              <div
                class="
                  kvc-opencard-header
                  px-3
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <div>Question Behaviour</div>
                <div>
                  <img
                    src="../../../assets/img/newvendorflow/uparw.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="p-3">
              <b-row>
                <b-col>
                  <div class="kvc-cards-header">
                    <img
                      src="../../../assets/img/newvendorflow/smallcalendar.svg"
                      alt=""
                      class="mr-1"
                    />
                    Start Date & Time
                  </div>
                  <div class="kvc-cards-subheader mt-1">
                    {{ getConvertedOpen.substring(0, 10) | formatDate }},
                    {{ getConvertedOpen.substring(11, 16) }}
                  </div>
                </b-col>
                <b-col>
                  <div class="kvc-cards-header">
                    <img
                      src="../../../assets/img/newvendorflow/smallcalendar.svg"
                      alt=""
                      class="mr-1"
                    />
                    End Date & Time
                  </div>
                  <div class="kvc-cards-subheader mt-1">
                    {{ getConvertedClose.substring(0, 10) | formatDate }},
                    {{ getConvertedClose.substring(11, 16) }}
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="kvc-cards-header mt-3">Duration</div>
                  <div class="kvc-cards-subheader mt-1">
                    {{ configuration.config.testDuration }}
                  </div>
                </b-col>
                <b-col>
                  <div class="kvc-cards-header mt-3">
                    Specify Negative Marks
                  </div>
                  <div class="kvc-cards-subheader mt-1">
                    {{ configuration.config.negativeMarkValue }}
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="kvc-cards-header mt-3">
                    Maximum Number of Attempts
                  </div>
                  <div class="kvc-cards-subheader mt-1">
                    {{ configuration.config.maxnoattempts }}
                  </div>
                </b-col>
                <b-col>
                  <div class="kvc-cards-header mt-3">
                    Buffer Time (minutes)*
                  </div>
                  <div class="kvc-cards-subheader mt-1">
                    {{ configuration.config.buffertime }} Mins
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="kvc-cards-header mt-3">Passing Percentage</div>
                  <div class="kvc-cards-subheader mt-1 text-capitalize">
                    {{ configuration.config.passingPercentage }}
                  </div>
                </b-col>
                <b-col>
                  <div class="kvc-cards-header mt-3">
                    Number of questions per screen
                  </div>
                  <div class="kvc-cards-subheader mt-1">
                    {{ configuration.config.quesPerScreen }}
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="configuration.config.maxnoattempts > 1">
                <b-col>
                  <div class="kvc-cards-header mt-3">Priority Attempt</div>
                  <div class="kvc-cards-subheader mt-1 text-capitalize">
                    {{ configuration.config.priority }}
                  </div>
                </b-col>
              </b-row>
              <hr class="my-2" style="border-bottom: 1px solid #d9d9d9" />
              <b-row>
                <b-col cols="6" v-if="configuration.config.displayReqFirst">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Display Mandatory Questions First</div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.dispMarks">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Display Marks for every Questions</div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.shuffle">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Randomly Shuffle Questions</div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.dispReqStatus">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Display Mandatory Questions Icon</div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>

        <!-- System Setup -->
        <div
          class="pointer mt-3"
          v-if="!display.showSystsem && dispSystemSetup"
          @click="showCard('showSystsem')"
        >
          <div
            class="
              p-3
              kanban-viewconfig-card-container
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <div>System Setup</div>
            <div>
              <img src="../../../assets/img/newvendorflow/downarw.svg" alt="" />
            </div>
          </div>
        </div>
        <div
          class="mt-3"
          v-else-if="display.showSystsem"
          @click="showCard('showSystsem')"
        >
          <div class="kanban-viewconfig-opencard-container">
            <div class="pointer">
              <div
                class="
                  kvc-opencard-header
                  px-3
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <div>System Setup</div>
                <div>
                  <img
                    src="../../../assets/img/newvendorflow/uparw.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="pb-3 pl-3 pr-3">
              <b-row>
                <b-col cols="6" v-if="configuration.config.communicationTest">
                  <div class="kvc-cards-subheader d-flex">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>
                      <div>Communication Test</div>
                      <div class="kvc-cards-header mt-1">
                        Test Attempts :
                        <span class="kvc-cards-subheader">{{
                          configuration.config.communicationTestAttempts
                        }}</span>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.enableProctoring">
                  <div class="kvc-cards-subheader d-flex">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Enabled Proctoring</div>
                  </div>
                </b-col>
                <b-col
                  cols="6"
                  v-if="configuration.config.allowImageAndIdCapture"
                >
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Allow Image And ID Capture</div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.typingTest">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Typing Test</div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.instantemail">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Instant Test Result</div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.allowAgent">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Allow Agent</div>
                  </div>
                </b-col>
                <b-col
                  cols="6"
                  v-if="configuration.config.allowCandidateRemarks"
                >
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Allow Candidate Feedback</div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.enableScreenShare">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Enable Screen Share</div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.includeTimeNotifics">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Include Time Sensitivity Notifications</div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.allowExtension">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Allow Extension</div>
                  </div>
                </b-col>
                <b-col cols="6" v-if="configuration.config.internetCheck">
                  <div class="kvc-cards-subheader d-flex mt-3">
                    <div>
                      <img
                        src="../../../assets/img/newvendorflow/smalltick.svg"
                        alt=""
                        class="mr-1"
                      />
                    </div>
                    <div>Enable Internet Check</div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <!-- Do's and Dont's -->
        <div
          class="pointer mt-3"
          v-if="!display.showDos"
          @click="showCard('showDos')"
        >
          <div
            class="
              p-3
              kanban-viewconfig-card-container
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <div>Do's and Dont's</div>
            <div>
              <img src="../../../assets/img/newvendorflow/downarw.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="mt-3" v-else @click="showCard('showDos')">
          <div class="kanban-viewconfig-opencard-container">
            <div class="pointer">
              <div
                class="
                  kvc-opencard-header
                  px-3
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <div>Do's and Dont's</div>
                <div>
                  <img
                    src="../../../assets/img/newvendorflow/uparw.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="p-3">
              <!-- after first index give a class mt-2 -->
              <div
                class="d-flex align-items-baseline w-100"
                v-for="(data, index) in configuration.config.dosAndDonts"
                :key="'do' + index"
                :class="index != 0 ? 'mt-2' : ''"
              >
                <div style="width: 3%">
                  <div class="kvc-dos-point"></div>
                </div>

                <div class="kvc-cards-subheader ml-2" style="width: 97%">
                  {{ data.value }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { convertTime } from "../../../controllers/workbench/helpers";
export default {
  name: "ViewConfig",
  props: {
    showModal: Boolean,
    selectedProcess: Object,
  },
  data() {
    return {
      display: {
        showOpenScreen: true,
        showQuesBehav: false,
        showSystsem: false,
        showDos: false,
      },
      configuration: {},
    };
  },
  created() {
    this.configuration = {
      config: this.selectedProcess.config,
      configName: this.selectedProcess.configName,
      configID: this.selectedProcess.configID,
    };
  },
  computed: {
    getConvertedClose() {
      return convertTime(this.configuration.config.closeTestdt, "india");
    },
    getConvertedOpen() {
      return convertTime(this.configuration.config.openTestdt, "india");
    },
    dispSystemSetup() {
      if (
        this.configuration.config.communicationTest ||
        this.configuration.config.enableProctoring ||
        this.configuration.config.allowImageAndIdCapture ||
        this.configuration.config.typingTest ||
        this.configuration.config.instantemail |
          this.configuration.config.allowAgent ||
        this.configuration.config.allowCandidateRemarks ||
        this.configuration.config.enableScreenShare ||
        this.configuration.config.includeTimeNotifics ||
        this.configuration.config.allowExtension ||
        this.configuration.config.internetCheck
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    showCard(type) {
      this.display[type] = !this.display[type];
      for (var i in this.display) {
        if (i != type) {
          this.display[i] = false;
        }
      }
    },
  },
};
</script>

<style scoped></style>
